import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";

export default function KnownRegNumberFields({data, handlers}) {

    return (
        <div className="row known-reg-num-block">

            {/* Registration number */}

            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 "
                labelText="Registration number"
                required={true}
                controlName="carRegistrationNumber"
                value={data.carRegistrationNumber}
                onChange={handlers.onControlChange}
                inputAttrs={{
                    maxLength: 50
                }}
            />

            {/* Car's make and model */}

            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 "
                labelText="Car's make and model"
                required={false}
                controlName="carMakeAndModel"
                value={data.carMakeAndModel}
                onChange={handlers.onControlChange}
                inputAttrs={{
                    maxLength: 50
                }}
            />

            {/* Estimated car value */}

            <ScrollableTextBoxBlock
                type="number"
                containerCssClass="col-12 py-3 "
                labelText="Estimated car value"
                required={false}
                controlName="carEstimatedValue"
                value={data.carEstimatedValue}
                onChange={handlers.onControlChange}
                inputAttrs={{
                    maxLength: 50
                }}
            />


        </div>
    );

}